import React from 'react';
import styles from './Benefits.module.css';

import Button2 from '../button2/Button2';
import GridLayout from '../grid-layout/GridLayout';

import one from '../../assets/absolute1.png';
import two from '../../assets/absolute2.png';

const Benefits = () => {
    return (
        <div id="about" className={styles.supreme}>
        <div className={styles.parent}>
            <Button2 text="ABOUT" />
            <h3>Why People Love<br /> <span>Fusionsip</span></h3>
            <GridLayout />
            <img src={one} alt="one" className={styles.one} />
            <img src={two} alt="two" className={styles.two} />
        </div>
        </div>
    )
}

export default Benefits;